import { Component, OnInit, Input } from '@angular/core';

import { ChartService } from '../../services/chart.service';
import { UtilService } from '../../services/util.service';

@Component({
  selector: 'nb-classify-output',
  templateUrl: './nb-classify-output.component.html'
})
export class NbClassifyOutputComponent implements OnInit {

  classifyData: any;
  csv: string;
  classifyCategoryChart: any;
  hasData: boolean = false;
  showVerbose: boolean = false;

  @Input()
  set data(data: any) {
    this.classifyData = data;
    this.updateView();
  }

  constructor(private chartService: ChartService,
              private utilService: UtilService) {
    this.classifyCategoryChart = this.chartService.defaultChart;
    this.classifyCategoryChart.chart.type = 'bar';
    this.classifyCategoryChart.chart.height = '460';
    this.classifyCategoryChart.legend.enabled = false;
    this.classifyCategoryChart.yAxis.title = {
      text: 'Category probability'
    };
    this.classifyCategoryChart.xAxis.labels = {
      style: {
        fontSize: '14px'
      }
    };

    this.classifyCategoryChart.yAxis.labels = {
      style: {
        fontSize: '14px'
      },
      format: '{value}%'
    };
  }

  ngOnInit() {
  }

  updateView() {
    this.hasData = false;
    this.csv = '';
    this.classifyCategoryChart.series = [{data:[]}];
    this.classifyCategoryChart.xAxis.categories = [];
    var idx=0;

    if (this.classifyData.classify_data && this.classifyData.classify_data.length > 0) {
      var override = '';
      if (this.classifyData.type != this.classifyData.classify_data[0].c) {
        override = this.classifyData.type;
      }
      this.classifyData.classify_data.forEach((category) => {
        var color = this.chartService.primaryGradientColors[idx++];
        if (override == category.c) {
          color = this.chartService.defaultColors[1];
        }
        this.classifyCategoryChart.xAxis.categories.push(category.c);
        this.classifyCategoryChart.series[0].data.push({
          name: category.c,
          color: color,
          y: this.utilService.roundDecimal(category.p*100, 2)
        });
      });

      let temp = JSON.parse(JSON.stringify(this.classifyData.classify_data));
      temp = temp.sort( (a, b) => {
        if (a.c > b.c) {
          return 1;
        }
        else {
          return -1;
        }
      });
      temp.forEach((t) => {
        this.csv += `${Math.floor(t.s * 100) / 100},${Math.floor(t.p * 10000) / 10000},`;
      });
      this.hasData = true;
    }
  }

}



// WEBPACK FOOTER //
// ./client/app/admin/classify-output/nb-classify-output.component.ts